import React from 'react'
import { Link } from 'react-router-dom'
import image1 from '../assets/image-carousel-1.jpg'
import georgeImage from '../assets/George.png'
import officePlaceholder from '../assets/office_placeholder.png'

const About = () => {
  const aboutStyles = {
    container: {
      width: '100%',
      position: 'relative',
    },
    // Hero Section
    heroSection: {
      position: 'relative',
      padding: '150px 20px 100px',
      color: '#fff',
      textAlign: 'center',
      backgroundImage: `url(${image1})`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
      minHeight: '600px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '100%',
      zIndex: 1,
    },
    heroOverlay: {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(6, 67, 95, 0.7)',
      zIndex: 1,
    },
    heroContainer: {
      maxWidth: '1200px',
      margin: '0 auto',
      position: 'relative',
      zIndex: 2,
    },
    heroTitle: {
      fontSize: '3rem',
      fontWeight: '700',
      marginBottom: '20px',
      fontFamily: 'Poppins, sans-serif',
      color: '#fff',
      textShadow: '2px 2px 4px rgba(0, 0, 0, 0.5)',
    },
    heroSubtitle: {
      fontSize: '1.3rem',
      lineHeight: '1.8',
      opacity: 0.95,
      maxWidth: '800px',
      margin: '0 auto',
      color: '#fff',
      textShadow: '1px 1px 2px rgba(0, 0, 0, 0.5)',
    },
    // About Content Section
    aboutSection: {
      padding: '80px 20px',
      backgroundColor: '#fff',
    },
    aboutContainer: {
      maxWidth: '1200px',
      margin: '0 auto',
    },
    sectionTitle: {
      fontSize: '2.5rem',
      fontWeight: '700',
      color: 'var(--color-primary)',
      marginBottom: '30px',
      fontFamily: 'Poppins, sans-serif',
      textAlign: 'center',
    },
    sectionSubtitle: {
      fontSize: '1.2rem',
      color: '#666',
      lineHeight: '1.8',
      marginBottom: '30px',
      textAlign: 'center',
      maxWidth: '900px',
      margin: '0 auto 40px',
    },
    // Mission Vision Values Section
    mvvSection: {
      padding: '80px 20px',
      backgroundColor: '#f8f9fa',
    },
    mvvContainer: {
      maxWidth: '1200px',
      margin: '0 auto',
    },
    mvvGrid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
      gap: '40px',
      marginTop: '50px',
    },
    mvvCard: {
      backgroundColor: '#fff',
      padding: '40px 30px',
      borderRadius: '10px',
      boxShadow: '0 5px 15px rgba(0, 0, 0, 0.1)',
      textAlign: 'center',
      transition: 'transform 0.3s ease, box-shadow 0.3s ease',
    },
    mvvCardHover: {
      transform: 'translateY(-5px)',
      boxShadow: '0 10px 25px rgba(0, 0, 0, 0.15)',
    },
    mvvIcon: {
      fontSize: '3.5rem',
      marginBottom: '20px',
      color: 'var(--color-secondary)',
    },
    mvvTitle: {
      fontSize: '1.8rem',
      fontWeight: '600',
      color: 'var(--color-primary)',
      marginBottom: '20px',
    },
    mvvDescription: {
      fontSize: '1rem',
      color: '#666',
      lineHeight: '1.8',
    },
    // History Section
    historySection: {
      padding: '80px 20px',
      backgroundColor: '#fff',
    },
    historyContainer: {
      maxWidth: '1200px',
      margin: '0 auto',
    },
    historyContent: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
      gap: '50px',
      alignItems: 'center',
      marginTop: '40px',
    },
    historyText: {
      fontSize: '1.1rem',
      color: '#666',
      lineHeight: '1.8',
      marginBottom: '20px',
    },
    historyImage: {
      width: '100%',
      height: '400px',
      backgroundColor: '#e0e0e0',
      borderRadius: '10px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      border: '2px dashed #ccc',
    },
    placeholderText: {
      fontSize: '1.1rem',
      color: '#999',
      textAlign: 'center',
      padding: '20px',
    },
    // Values List Section
    valuesSection: {
      padding: '80px 20px',
      backgroundColor: '#f8f9fa',
    },
    valuesContainer: {
      maxWidth: '1200px',
      margin: '0 auto',
    },
    valuesGrid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
      gap: '30px',
      marginTop: '50px',
    },
    valueItem: {
      backgroundColor: '#fff',
      padding: '30px 25px',
      borderRadius: '10px',
      boxShadow: '0 3px 10px rgba(0, 0, 0, 0.1)',
      textAlign: 'center',
      transition: 'transform 0.3s ease',
    },
    valueItemHover: {
      transform: 'translateY(-3px)',
    },
    valueIcon: {
      fontSize: '2.5rem',
      marginBottom: '15px',
      color: 'var(--color-secondary)',
    },
    valueTitle: {
      fontSize: '1.3rem',
      fontWeight: '600',
      color: 'var(--color-primary)',
      marginBottom: '10px',
    },
    valueDescription: {
      fontSize: '0.95rem',
      color: '#666',
      lineHeight: '1.6',
    },
    // Team Section
    teamSection: {
      padding: '80px 20px',
      backgroundColor: '#fff',
    },
    teamContainer: {
      maxWidth: '1200px',
      margin: '0 auto',
    },
    teamContent: {
      display: 'flex',
      alignItems: 'center',
      gap: '50px',
      marginTop: '50px',
      flexWrap: 'wrap',
    },
    teamImageContainer: {
      flex: '0 0 380px',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    teamImage: {
      width: '420px',
      height: '420px',
      borderRadius: '50%',
      backgroundColor: '#fff',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      border: '4px solid var(--color-secondary)',
      boxShadow: '0 5px 20px rgba(0, 0, 0, 0.1)',
    },
    teamTextContainer: {
      flex: '1',
      minWidth: '300px',
    },
    teamNameContainer: {
      display: 'flex',
      alignItems: 'center',
      gap: '15px',
      flexWrap: 'wrap',
      marginBottom: '15px',
    },
    teamName: {
      fontSize: '2rem',
      fontWeight: '700',
      color: 'var(--color-primary)',
      fontFamily: 'Poppins, sans-serif',
      margin: 0,
    },
    teamQualifications: {
      fontSize: '1.1rem',
      color: '#666',
      fontWeight: '500',
      margin: 0,
    },
    teamRole: {
      fontSize: '1.3rem',
      color: 'var(--color-secondary)',
      marginBottom: '25px',
      fontWeight: '600',
    },
    teamBio: {
      fontSize: '1.05rem',
      color: '#666',
      lineHeight: '1.8',
    },
    // CTA Section
    ctaSection: {
      padding: '80px 20px',
      backgroundColor: 'var(--color-secondary)',
      color: '#fff',
      textAlign: 'center',
    },
    ctaContainer: {
      maxWidth: '800px',
      margin: '0 auto',
    },
    ctaTitle: {
      fontSize: '2.5rem',
      fontWeight: '700',
      marginBottom: '20px',
      color: '#fff',
    },
    ctaDescription: {
      fontSize: '1.2rem',
      lineHeight: '1.8',
      marginBottom: '40px',
      opacity: 0.95,
    },
    ctaButton: {
      backgroundColor: '#fff',
      color: 'var(--color-secondary)',
      padding: '15px 40px',
      fontSize: '1.1rem',
      fontWeight: '600',
      border: 'none',
      borderRadius: '5px',
      cursor: 'pointer',
      transition: 'transform 0.3s ease, box-shadow 0.3s ease',
      textDecoration: 'none',
      display: 'inline-block',
    },
  };

  return (
    <div style={aboutStyles.container}>
      {/* Hero Section */}
      <section style={aboutStyles.heroSection} data-aos="fade-down">
        <div style={aboutStyles.heroOverlay}></div>
        <div style={aboutStyles.heroContainer}>
          <h1 style={aboutStyles.heroTitle}>About Us</h1>
          <p style={aboutStyles.heroSubtitle}>
            Leading the maritime industry with excellence, integrity, and a commitment to providing 
            world-class offshore crew manning services across the globe.
          </p>
        </div>
      </section>

      {/* Leadership Section */}
      <section style={aboutStyles.teamSection} data-aos="fade-up">
        <div style={aboutStyles.teamContainer}>
          <h2 style={aboutStyles.sectionTitle}>Our Leadership</h2>
          <div style={aboutStyles.teamContent}>
            <div style={aboutStyles.teamImageContainer} data-aos="fade-right" data-aos-delay="100">
              <div style={{...aboutStyles.teamImage, overflow: 'hidden'}}>
                <img
                  src={georgeImage}
                  alt="S. George Fernando - Proprietor"
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                    objectPosition: 'center center',
                    borderRadius: '50%',
                    transform: 'scale(1.5)',
                  }}
                />
              </div>
            </div>
            <div style={aboutStyles.teamTextContainer} data-aos="fade-left" data-aos-delay="200">
              <div style={aboutStyles.teamNameContainer}>
                <h3 style={aboutStyles.teamName}>S. George Fernando</h3>
                <span style={aboutStyles.teamQualifications}>B.com, DCA, CCS</span>
              </div>
              <p style={aboutStyles.teamRole}>Proprietor</p>
              <p style={aboutStyles.teamBio}>
                With extensive experience in maritime operations and crew management, 
                S. George Fernando leads the company with a vision for excellence and 
                a commitment to providing world-class services. His expertise and 
                dedication have been instrumental in establishing Bill Gates Offshore 
                Crew Manning Services as a trusted name in the maritime industry.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* About Content Section */}
      <section style={aboutStyles.aboutSection} data-aos="fade-up">
        <div style={aboutStyles.aboutContainer}>
          <h2 style={aboutStyles.sectionTitle}>Who We Are</h2>
          <p style={aboutStyles.sectionSubtitle}>
            Bill Gates Offshore Crew Manning Services is a premier provider of skilled maritime 
            professionals for offshore operations worldwide. With over 15 years of experience in 
            the industry, we have established ourselves as a trusted partner for companies seeking 
            reliable, qualified, and certified crew members for their offshore projects.
          </p>
          <p style={aboutStyles.sectionSubtitle}>
            Our company is based in Uvari, Tamilnadu, South India, and operates globally, serving 
            clients across continents. We specialize in recruiting, training, and managing maritime 
            professionals who meet the highest international standards for safety, competence, and 
            professionalism.
          </p>
        </div>
      </section>

      {/* Mission, Vision, Values Section */}
      <section style={aboutStyles.mvvSection} data-aos="fade-up">
        <div style={aboutStyles.mvvContainer}>
          <h2 style={aboutStyles.sectionTitle}>Our Mission, Vision & Values</h2>
          <div style={aboutStyles.mvvGrid}>
            <div
              style={aboutStyles.mvvCard}
              data-aos="fade-up"
              data-aos-delay="100"
              onMouseEnter={(e) => {
                Object.assign(e.currentTarget.style, aboutStyles.mvvCardHover);
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 5px 15px rgba(0, 0, 0, 0.1)';
              }}
            >
              <div style={aboutStyles.mvvIcon}>🎯</div>
              <h3 style={aboutStyles.mvvTitle}>Our Mission</h3>
              <p style={aboutStyles.mvvDescription}>
                To provide exceptional offshore crew manning services by connecting skilled maritime 
                professionals with global opportunities, ensuring safety, compliance, and operational 
                excellence in every deployment.
              </p>
            </div>

            <div
              style={aboutStyles.mvvCard}
              data-aos="fade-up"
              data-aos-delay="200"
              onMouseEnter={(e) => {
                Object.assign(e.currentTarget.style, aboutStyles.mvvCardHover);
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 5px 15px rgba(0, 0, 0, 0.1)';
              }}
            >
              <div style={aboutStyles.mvvIcon}>👁️</div>
              <h3 style={aboutStyles.mvvTitle}>Our Vision</h3>
              <p style={aboutStyles.mvvDescription}>
                To become the world's most trusted and respected offshore crew manning service provider, 
                recognized for our commitment to quality, innovation, and the success of our clients 
                and crew members worldwide.
              </p>
            </div>

            <div
              style={aboutStyles.mvvCard}
              data-aos="fade-up"
              data-aos-delay="300"
              onMouseEnter={(e) => {
                Object.assign(e.currentTarget.style, aboutStyles.mvvCardHover);
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 5px 15px rgba(0, 0, 0, 0.1)';
              }}
            >
              <div style={aboutStyles.mvvIcon}>💎</div>
              <h3 style={aboutStyles.mvvTitle}>Our Values</h3>
              <p style={aboutStyles.mvvDescription}>
                Integrity, professionalism, safety, and excellence guide everything we do. We are 
                committed to building lasting relationships based on trust, transparency, and mutual 
                respect with our clients and crew members.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* History Section */}
      <section style={aboutStyles.historySection} data-aos="fade-up">
        <div style={aboutStyles.historyContainer}>
          <h2 style={aboutStyles.sectionTitle}>Our Journey</h2>
          <div style={aboutStyles.historyContent}>
            <div>
              <p style={aboutStyles.historyText}>
                Founded with a vision to bridge the gap between skilled maritime professionals and 
                global offshore opportunities, Bill Gates Offshore Crew Manning Services has grown 
                from a local operation to an internationally recognized crew manning company.
              </p>
              <p style={aboutStyles.historyText}>
                Our journey began with a simple yet powerful mission: to provide exceptional service 
                while ensuring the highest standards of safety and professionalism. Over the years, 
                we have successfully placed thousands of qualified crew members in offshore operations 
                across the world.
              </p>
              <p style={aboutStyles.historyText}>
                Today, we continue to expand our network, enhance our services, and invest in training 
                and development programs to ensure our crew members are equipped with the latest 
                skills and certifications required in the modern maritime industry.
              </p>
            </div>
            <div
              style={{
                ...aboutStyles.historyImage,
                backgroundColor: 'transparent',
                border: 'none',
                overflow: 'hidden',
              }}
              data-aos="zoom-in"
            >
              <img
                src={officePlaceholder}
                alt="Offshore crew and platform"
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover',
                  borderRadius: '10px',
                }}
              />
            </div>
          </div>
        </div>
      </section>

      {/* Core Values Section */}
      <section style={aboutStyles.valuesSection} data-aos="fade-up">
        <div style={aboutStyles.valuesContainer}>
          <h2 style={aboutStyles.sectionTitle}>Core Values</h2>
          <div style={aboutStyles.valuesGrid}>
            <div
              style={aboutStyles.valueItem}
              data-aos="zoom-in"
              data-aos-delay="100"
              onMouseEnter={(e) => {
                Object.assign(e.currentTarget.style, aboutStyles.valueItemHover);
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
              }}
            >
              <div style={aboutStyles.valueIcon}>🛡️</div>
              <h3 style={aboutStyles.valueTitle}>Safety First</h3>
              <p style={aboutStyles.valueDescription}>
                Uncompromising commitment to safety standards and protocols
              </p>
            </div>

            <div
              style={aboutStyles.valueItem}
              data-aos="zoom-in"
              data-aos-delay="200"
              onMouseEnter={(e) => {
                Object.assign(e.currentTarget.style, aboutStyles.valueItemHover);
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
              }}
            >
              <div style={aboutStyles.valueIcon}>⭐</div>
              <h3 style={aboutStyles.valueTitle}>Excellence</h3>
              <p style={aboutStyles.valueDescription}>
                Striving for excellence in every aspect of our service delivery
              </p>
            </div>

            <div
              style={aboutStyles.valueItem}
              data-aos="zoom-in"
              data-aos-delay="300"
              onMouseEnter={(e) => {
                Object.assign(e.currentTarget.style, aboutStyles.valueItemHover);
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
              }}
            >
              <div style={aboutStyles.valueIcon}>🤝</div>
              <h3 style={aboutStyles.valueTitle}>Integrity</h3>
              <p style={aboutStyles.valueDescription}>
                Building trust through honest and transparent business practices
              </p>
            </div>

            <div
              style={aboutStyles.valueItem}
              data-aos="zoom-in"
              data-aos-delay="400"
              onMouseEnter={(e) => {
                Object.assign(e.currentTarget.style, aboutStyles.valueItemHover);
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
              }}
            >
              <div style={aboutStyles.valueIcon}>🌍</div>
              <h3 style={aboutStyles.valueTitle}>Global Reach</h3>
              <p style={aboutStyles.valueDescription}>
                Connecting talent with opportunities across the world
              </p>
            </div>

            <div
              style={aboutStyles.valueItem}
              data-aos="zoom-in"
              data-aos-delay="500"
              onMouseEnter={(e) => {
                Object.assign(e.currentTarget.style, aboutStyles.valueItemHover);
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
              }}
            >
              <div style={aboutStyles.valueIcon}>📚</div>
              <h3 style={aboutStyles.valueTitle}>Continuous Learning</h3>
              <p style={aboutStyles.valueDescription}>
                Investing in training and development for continuous improvement
              </p>
            </div>

            <div
              style={aboutStyles.valueItem}
              data-aos="zoom-in"
              data-aos-delay="600"
              onMouseEnter={(e) => {
                Object.assign(e.currentTarget.style, aboutStyles.valueItemHover);
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
              }}
            >
              <div style={aboutStyles.valueIcon}>💼</div>
              <h3 style={aboutStyles.valueTitle}>Professionalism</h3>
              <p style={aboutStyles.valueDescription}>
                Maintaining the highest standards of professional conduct
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section style={aboutStyles.ctaSection} data-aos="fade-up">
        <div style={aboutStyles.ctaContainer}>
          <h2 style={aboutStyles.ctaTitle}>Ready to Work With Us?</h2>
          <p style={aboutStyles.ctaDescription}>
            Discover how our expertise and commitment to excellence can support your offshore 
            operations. Get in touch with us today to discuss your crew manning needs.
          </p>
          <Link
            to="/contact"
            style={aboutStyles.ctaButton}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'scale(1.05)';
              e.currentTarget.style.boxShadow = '0 5px 20px rgba(0, 0, 0, 0.2)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'scale(1)';
              e.currentTarget.style.boxShadow = 'none';
            }}
          >
            Contact Us
          </Link>
        </div>
      </section>
    </div>
  )
}

export default About